<div class="navbar-container" [class.example-is-mobile]="mobileQuery.matches">

  <!-- Top navbar -->
  <mat-toolbar class="navbar" color="primary">

    <button [ngStyle]="{display: mobileQuery.matches ? 'block' :'none' }" style="margin-right: 10px;" mat-icon-button (click)="snav.toggle()">
      <mat-icon>menu</mat-icon>
    </button>

    <a class="navbar-brand" [routerLink]="['/'+rol+'/dashboard']" matTooltip="Dashboard">
      <img src="../../../assets/logo/reflex_min2.png" style="height: 40px; margin-top: 5px;" />
    </a>

    <span class="navbar-spacer"></span>
    <button mat-button [matMenuTriggerFor]="userMenu">
      <mat-icon>person</mat-icon>
      <span fxShow fxHide.xs>
        {{userName}}
      </span>
    </button>
    <mat-menu #userMenu="matMenu" xPosition="before" yPosition="above" [overlapTrigger]="false">

      <a mat-menu-item [routerLink]="['/'+rol+'/account/profile']">
        <mat-icon>person</mat-icon>
        <span>Perfil</span>
      </a>

      <a mat-menu-item [routerLink]="['']" (click)='logOut()'>
        <mat-icon>exit_to_app</mat-icon>
        <span>Cerrar sesión</span>
      </a>

    </mat-menu>

  </mat-toolbar>

  <mat-sidenav-container class="navbar-sidenav-container">
    <!-- Side nav -->
    <mat-sidenav #snav id='navbar'[opened]="!mobileQuery.matches" [mode]="mobileQuery.matches ? 'over' : 'side'"
      [fixedInViewport]="mobileQuery.matches" fixedTopGap="56" class="sidenav">
      <mat-nav-list>

        <mat-accordion class="menu-sidebar">

          <a mat-list-item *ngFor='let item of menu[rol]' (click)='onCloseMenu(snav)' [routerLink]="['/'+rol+item.route]" routerLinkActive="active">
            <mat-icon mat-list-icon class="icon-menu-only" routerLinkActive="active">
              {{item.icon}}
            </mat-icon>
            <p class="title-menu-only" routerLinkActive="active"> {{item.label}} </p>
          </a>


        </mat-accordion>
      </mat-nav-list>                 
    </mat-sidenav>
    

    <!-- Main content -->
    <mat-sidenav-content class="sidenav-content">

      <div class="progress-bar-container">
        <!--<mat-progress-bar color="accent" mode="indeterminate" *ngIf="spinnerService.visibility | async">
        </mat-progress-bar>-->
        <!-- <mat-spinner class="spinner" [diameter]="50" *ngIf="showSpinner"></mat-spinner> -->
      </div>
      <router-outlet></router-outlet>

    </mat-sidenav-content>

  </mat-sidenav-container>

</div>